import { connect } from 'react-redux';
import AnalyticsAndCommonLogicComponent from './common_logic_component';
import { getMyAccountCredits, getUser, updateUser } from '../../actions/user';
import { loadHomePage } from '../../actions/home_page';
import {
  appLoading, getAnonymousUser, setDynamicConfig,
  setGoogleConfig, logOutClear
} from '../../actions/application';
import { getUserFirstActivePromotion } from '../../config/util';
import { initFirebaseDatabase, signOutFromFBDatabase } from '../../actions/firebase_realtime_database';
import { setForceLogout } from '../../actions/shared_actions';

const mapStateToProps = ({ user, application }) => ({
  userId: user && user.user && user.user.id,
  userEmail: user && user.user && user.user.email,
  user: user && user.user,
  userPaymentProcessing: ((user || {}).user || {}).paymentProcessing,
  userFirstActivePromotion: getUserFirstActivePromotion({ user, application }),
  dynamicConfig: application.dynamicConfig,
  forceLogout: application.forceLogout
});

export default connect(
  mapStateToProps,
  {
    getUser,
    loadHomePage,
    getMyAccountCredits,
    appLoading,
    getAnonymousUser,
    initFirebaseDatabase,
    signOutFromFBDatabase,
    setDynamicConfig,
    setForceLogout,
    setGoogleConfig,
    updateUser,
    logOutClear
  }
)(AnalyticsAndCommonLogicComponent);
